import React from 'react';
import ProductHeader from '../../components/ProductHeader/ProductHeader';
import Footer from '../../components/Footer/Footer';
import Menu from '../../components/Menu/Menu';
import ProductHeroSection from '../../components/ProductHeroSection/ProductHeroSection';
import ProductList from '../../components/ProductList/ProductList';
import './Product.css';

const Product = () => {
  return (
    <>
      <ProductHeader />
      <Menu />
      <main>
        <ProductHeroSection />
        <ProductList />
      </main>
      <Footer />
    </>
  );
};

export default Product;